export function isPastOrDateless(event, nowTs = Math.floor(Date.now() / 1000)) {
	const ts = Number(event.record_date || event.date);
	return !ts || ts <= nowTs;
}
